import ChipColors from './ChipColors';

export default [
  {
    text: 'Normal',
    value: 'NORMAL',
    ...ChipColors.success,
  },
  {
    text: 'Bloqueio preventivo',
    value: 'PREVENTIVO',
    ...ChipColors.warning,
  },
  {
    text: 'Bloqueio indeterminado',
    value: 'INDETERMINADO',
    ...ChipColors.danger,
  },
  {
    text: 'Automático',
    value: 'AUTOMATICO',
    ...ChipColors.neutral,
  },
];
